<template>
  <b-modal
    v-model="isVisible"
    :hide-footer="true"
    centered
    no-close-on-backdrop
    @hidden="onModalHidden"
  >
    <b-row>
      <b-col cols="12">
        {{ $t('otp-description', { type: twoFactorTypeLabel }) }}
      </b-col>
      <b-col
        cols="12"
        class="my-1"
      >
        <flip-countdown
          :label="{
            hours: `${$t('hour')}`,
            minutes: `${$t('minute')}`,
            seconds: `${$t('second')}`
          }"
          :style="{ direction: 'ltr' }"
          :deadline="deadline"
          :show-days="false"
          :show-hours="false"
          @timeElapsed="timeElapsedHandler"
        />
      </b-col>
      <b-col cols="12">
        <validation-observer
          ref="verifyForm"
        >
          <form
            @submit.stop.prevent="handleOTP"
          >
            <b-form-group
              invalid-feedback="Verification code is required"
              label-for="verification_code"
              :label="$t('verification_code')"
            >
              <div id="divOuter">
                <div id="divInner">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('verification_code')"
                    vid="verification-code"
                    rules="required"
                  >
                    <b-form-input
                      id="partitioned"
                      v-model="verifyCode"
                      maxlength="6"
                      oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                      on-key-press="if(this.value.length==4) return false;"
                      required
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
              </div>
            </b-form-group>
            <b-row align-h="between">
              <b-col cols="auto">
                <b-button
                  variant="success"
                  :disabled="verifyCode.length < 4"
                  @click="handleOTP"
                >
                  <span v-if="!pendingOtp">{{ $t('save') }}</span>
                  <span v-else>
                    <b-spinner
                      small
                      type="grow"
                    />
                  </span>
                </b-button>
              </b-col>
              <b-col cols="auto">
                <b-button
                  variant="primary"
                  :disabled="!reSendBtn"
                  @click="resendOTP"
                >
                  <span v-if="!pendingReSendOtp">{{ $t('re-send') }}</span>
                  <span v-else>
                    <b-spinner
                      small
                      type="grow"
                    />
                  </span>
                </b-button>
              </b-col>
            </b-row>
          </form>
        </validation-observer>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import FlipCountdown from 'vue2-flip-countdown'
import OtpVerificationModalLogic from '@/views/logics/components/OtpVerificationModal'

export default {
  name: 'OtpVerificationModal',
  components: {
    FlipCountdown,
  },

  mixins: [OtpVerificationModalLogic],

}
</script>
